import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5474e59c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buffer" }
const _hoisted_2 = { class: "tips" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "考试须知", -1))
const _hoisted_4 = { class: "title2" }
const _hoisted_5 = { class: "times" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rules" }, [
  /*#__PURE__*/_createElementVNode("p", null, "（1）请勾选【我已阅读】进入考试，考试期间，请家长离场；"),
  /*#__PURE__*/_createElementVNode("p", null, "（2）监考人员不回答关于考试任何问题；"),
  /*#__PURE__*/_createElementVNode("p", null, "（3）考试过程请所有学员保持安静，以免打扰其他学员测评；"),
  /*#__PURE__*/_createElementVNode("p", null, "（4）请安装制定的Google浏览器，并保持网络畅通；"),
  /*#__PURE__*/_createElementVNode("p", null, "（5）请不要随意切换考试界面，超过一定次数将结束本次测评；"),
  /*#__PURE__*/_createElementVNode("p", null, "（6）要完成纸质版答题卡的填写；"),
  /*#__PURE__*/_createElementVNode("p", null, "（7）请在【提交】考试后的【5分钟内】将纸质版答题卡拍照发给监考人员。")
], -1))
const _hoisted_7 = { class: "check" }
const _hoisted_8 = { class: "btns" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("开始答题")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.examData.content), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.examData.startTime) + "——" + _toDisplayString(_ctx.examData.endTime), 1),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_checkbox, {
          checked: _ctx.checked,
          onChange: _ctx.isChecked,
          label: "我已阅读上述考试须知",
          size: "large"
        }, null, 8, ["checked", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          round: "",
          color: "#50212F",
          size: "large",
          onClick: _ctx.next
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}